export default __webpack_public_path__ + "static/media/padlock_on_icon.51838d25.svg";